module.exports = __webpack_public_path__ + "fonts/9d518bb0917d8800c548dff5657d2ab2.svg";